import { useState } from "react";
import { toast } from "sonner";
import { Key } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export default function ChangePasswordDialog({ onClose }) {
  const [code, setCode] = useState("");
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!code.trim()) { setError("Informe o código do colaborador."); return; }
    if (next.trim().length < 4) { setError("A nova senha deve ter pelo menos 4 caracteres."); return; }
    if (next !== confirm) { setError("A confirmação não confere com a nova senha."); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", {
        collaborator_code: code.trim(),
        current_password: current,
        new_password: next,
      });
      toast.success("Senha do colaborador alterada com sucesso");
      onClose();
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Falha ao trocar a senha. Tente novamente.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      onClick={() => !saving && onClose()}>
      <div className="glass max-w-md w-full p-6 md:p-8" onClick={(e) => e.stopPropagation()}
        data-testid="change-password-modal">
        <div className="flex items-start gap-4 mb-5">
          <div className="border border-black bg-yellow-50 p-2">
            <Key size={22} weight="bold" />
          </div>
          <div className="flex-1">
            <div className="overline text-zinc-500 mb-1">COLABORADOR</div>
            <h2 className="font-head text-2xl font-black tracking-tighter">Trocar Senha</h2>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <label className="overline text-[10px] text-zinc-500 block mb-1">Código do colaborador</label>
            <input type="text" inputMode="numeric" className="input w-full" value={code} autoFocus
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} required
              placeholder="Ex: 100"
              data-testid="change-password-code" />
          </div>
          <div>
            <label className="overline text-[10px] text-zinc-500 block mb-1">Senha atual</label>
            <input type="password" className="input w-full" value={current}
              onChange={(e) => setCurrent(e.target.value)} required
              data-testid="change-password-current" />
          </div>
          <div>
            <label className="overline text-[10px] text-zinc-500 block mb-1">Nova senha (mín. 4 caracteres)</label>
            <input type="password" className="input w-full" value={next} minLength={4}
              onChange={(e) => setNext(e.target.value)} required
              data-testid="change-password-new" />
          </div>
          <div>
            <label className="overline text-[10px] text-zinc-500 block mb-1">Confirmar nova senha</label>
            <input type="password" className="input w-full" value={confirm} minLength={4}
              onChange={(e) => setConfirm(e.target.value)} required
              data-testid="change-password-confirm" />
          </div>
          <p className="text-[10px] text-zinc-500">
            Esta senha é a do COLABORADOR — usada no login do painel e como PIN nas
            confirmações de movimentação. Senha de <b>estação</b> só o admin altera em
            Configurações → Logins de Estação.
          </p>
          {error && (
            <div className="text-xs text-red-600 border-l-4 border-red-500 bg-red-50 dark:bg-red-900/20 px-3 py-2 rounded"
              data-testid="change-password-error">{error}</div>
          )}
          <div className="flex gap-3 pt-1">
            <button type="button" className="btn btn-ghost flex-1" onClick={onClose} disabled={saving}
              data-testid="change-password-cancel">Cancelar</button>
            <button type="submit" className="btn flex-1" disabled={saving} data-testid="change-password-submit">
              <Key size={16} weight="bold" />
              {saving ? "Salvando..." : "Salvar Nova Senha"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
